/* eslint-disable import/prefer-default-export */
export const TEMP_DIRECT_LINK = 'TEMP_DIRECT_LINK';
export const DIRECT_LINK = 'DIRECT_LINK';
